module.exports = __webpack_public_path__ + "img/i_mytown_s_r.d586e798.svg";